<template>
    <div class="container-home-news">
        <SideHeader/>
        <div class="container-right">
            <div class="main-container-right">
                <TopHeaderLogin/>
                <div class="news-img-container">
                    <img :src="`${dataNews.img}`" alt="" v-for="dataNews in dataForRender" :key="dataNews.id">
                </div>
                <div class="news-container">
                    <div v-for="dataNews in dataForRender" :key="dataNews.id" class="news-header">
                        <h1>{{dataNews.title}}</h1>
                    </div>
                    <div v-for="dataNews in dataForRender" :key="dataNews.id" class="news-body">
                        <p>{{dataNews.content}}</p>
                    </div>                 
                </div>
                <!-- <div class="purchase-container">
                    <div class="purchase-header">
                        <h1>Lorem, ipsum dolor sit amet</h1>
                    </div>
                    <div class="purchase-body">
                        <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Eaque, officia? Nobis odio odit natus corporis sit accusantium deleniti. Inventore quibusdam corrupti laudantium necessitatibus tempora culpa vel itaque maxime, laboriosam unde.</p>
                    </div>
                    <div class="btn-purchase-container">
                        <a class="btn-purchase" href="#">PURCHASE</a>
                    </div>
                </div> -->
                <!-- <div class="recent-container">
                    <div class="recent-header">
                        <h1>Recent Post</h1>
                        <a href="">SEE ALL</a>
                    </div>
                    <div class="recent-body">
                        <a :href="`${dataNews.link}`" target="_blank" class="body-details-box" v-for="dataNews in recentPost" :key="dataNews.id" >
                            <img :src="`${dataNews.img}`" alt="">
                            <h1>{{dataNews.title}}</h1>
                        </a >
                    </div>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
import SideHeader from '@/components/Header/SideHeader.vue'
import TopHeaderLogin from '@/components/Header/TopHeaderLogin.vue'
import {ref,onMounted,reactive} from 'vue'
import {useRouter} from 'vue-router'

export default {
  name: 'RefferalView',
  components: {
    SideHeader,
    TopHeaderLogin
  },
  props:{
      
  },
  setup(){
      const route = useRouter()
      let dataForRender  = reactive([])
        let newsContent = ref([
          {
              id:1,
              params:'upgradeBahagiamu',
              title:'Pembelajaran Blended Learning dengan Media Virtual Reality (VR)',
              content:'Selama pandemi ini, beberapa negara seperti China, Colombia, dan bahkan Indonesia sendiri mengalami Learning Loss yang ditandai dengan rendahnya minat belajar peserta didik. MilleaLab yang merupakan all-in-one Virtual Reality platform hadir selama pandemi untuk menjadi solusi permasalahan yang terjadi pada pendidikan K-12. Sesuai dengan tagline MilleaLab yaitu #BahagiaBelajar, MilleaLab yakin bahwa dengan meningkatkan kebahagiaan pendidik dan peserta didik dalam kegiatan belajar mengajar, maka dapat menurunkan Learning Loss dan meningkatkan minat belajar peserta didik serta memberikan banyak impact baik lainnya untuk pendidikan. MilleaLab terbukti dapat meningkatkan kebahagiaan peserta didik dalam kegiatan belajar mengajar dengan data uji coba kepada 1.800 peserta didik di 10 provinsi di Indonesia yang membuktikan MilleaLab dapat meningkatkan emosi positif 80%, tingkat pemahaman 94% dan hasil belajar 38%. \n \n Dengan dampak yang telah diberikan oleh banyak pendidik dalam dunia pendidikan menggunakan teknologi Virtual Reality, melalui kerjasama antara MilleaLab dan sekolah-sekolah di Indonesia. MilleaLab mengajak Bapak/Ibu pendidik di seluruh Indonesia untuk #UpgradeBahagiamu dengan penggunaan teknologi Virtual Reality. MilleaLab meluncurkan lisensi individu bagi pendidik yang ingin terlibat aktif dalam mengembangkan konten pembelajaran berbasis teknologi Virtual Reality secara mandiri untuk terus meningkatkan kualitas pendidikan dan memberikan dampak positif dalam pendidikan dengan teknologi VR yang dapat diakses dengan mudah, cepat dan terjangkau. \n \n Dan kami berharap dengan campaign #UpgradeBahagiamu dapat memberikan akses dan fasilitas merata bagi dunia pendidikan di seluruh Indonesia dengan menggunakan teknologi Virtual Reality sehingga dapat menjadi solusi bagi para pendidik yang tergabung dalam platform MilleaLab serta dapat memberikan dampak baik lainnya untuk seluruh pendidik di Indonesia dalam menciptakan adopsi digital yang lebih luas.',
              img:[require('../assets/slider-home/bg-slide-1.png')]
          },
        //     {
        //       id:2,
        //       params:'upgradeBahagiaku',
        //       title:'Pembelajaran Blended Learning dengan Media Virtual Reality (VR)',
        //       content:`Selama pandemi ini, peserta didik mengalami Learning Loss dikarenakan kegiatan belajar mengajar dilakukan secara online. Beberapa negara seperti China, Colombia, dan bahkan Indonesia sendiri mengalami Learning Loss yang ditandai dengan rendahnya minat belajar peserta didik. MilleaLab yang merupakan all-in-one Virtual Reality platform hadir untuk menjadi solusi permasalahan yang terjadi pada pendidikan K-12. Sesuai dengan tagline MilleaLab yaitu #BahagiaBelajar, MilleaLab yakin bahwa dengan meningkatkan kebahagiaan pendidik dan peserta didik dalam kegiatan belajar mengajar, maka dapat menurunkan Learning Loss dan meningkatkan minat belajar peserta didik serta memberikan banyak impact baik lainnya untuk pendidikan. Dengan adanya campaign #UpgradeBahagiamu MilleaLab ingin mengajak pendidik, dan peserta didik dapat mengupgrade bahagianya dalam mengajar dan belajar dengan teknologi Virtual Reality MilleaLab.`,
        //       img:[require('../assets/slider-home/bg-slide-1.png')]
        //   },
        //    {
        //       id:3,
        //       params:'upgradeBahagiakita',
        //       title:'Pembelajaran Blended Learning dengan Media Virtual Reality (VR)',
        //       content:`Selama pandemi ini, peserta didik mengalami Learning Loss dikarenakan kegiatan belajar mengajar dilakukan secara online. Beberapa negara seperti China, Colombia, dan bahkan Indonesia sendiri mengalami Learning Loss yang ditandai dengan rendahnya minat belajar peserta didik. MilleaLab yang merupakan all-in-one Virtual Reality platform hadir untuk menjadi solusi permasalahan yang terjadi pada pendidikan K-12. Sesuai dengan tagline MilleaLab yaitu #BahagiaBelajar, MilleaLab yakin bahwa dengan meningkatkan kebahagiaan pendidik dan peserta didik dalam kegiatan belajar mengajar, maka dapat menurunkan Learning Loss dan meningkatkan minat belajar peserta didik serta memberikan banyak impact baik lainnya untuk pendidikan. Dengan adanya campaign #UpgradeBahagiamu Millealab ingin mengajak pendidik, dan peserta didik dapat mengupgrade bahagianya dalam mengajar dan belajar dengan teknologi Virtual Reality Millealab.`,
        //       img:[require('../assets/slider-home/bg-slide-1.png')]
        //   }
      ])
        let recentPost = reactive([
             {
              id:1,
              title:'Pembelajaran Blended Learning dengan Media Virtual Reality (VR)',
              img:[require('../assets/DiscountImg/Discount_1.jpg')],
              link:'https://www.millealab.com/post/millealab-bekerja-sama-dengan-lenteraedu-meluncurkan-program-virtual-reality-ambassadors'
          },
            {
              id:2,
              title:'Pembelajaran Blended Learning dengan Media Virtual Reality (VR)',
              img:[require('../assets/DiscountImg/Discount_2.jpg')],
              link:'https://www.millealab.com/post/millealab-bekerja-sama-dengan-lenteraedu-meluncurkan-program-virtual-reality-ambassadors'
          },
           {
              id:3,
              title:'Pembelajaran Blended Learning dengan Media Virtual Reality (VR)',
              img:[require('../assets/DiscountImg/Discount_3.jpg')],
              link:'https://www.millealab.com/post/millealab-bekerja-sama-dengan-lenteraedu-meluncurkan-program-virtual-reality-ambassadors'
          }
      ])

//  var searching = newAlamatCustomer.filter((filter)=>{
//                 if(filter.alamat.toUpperCase().includes(params.toUpperCase())){
//                     console.log(filter)
//                     data_searching.push(filter)
//                     return filter
//                 }
//             })
      const findContent=()=>{
          var filterItem = newsContent.value.filter((filter)=>{
            //   console.log(route.currentRoute.value.params.title)
              let paramsTitle = route.currentRoute.value.params.title
            //   console.log(filter.params, paramsTitle)
              if(filter.params === paramsTitle){
                  dataForRender.push(filter)
                  return filter
              }
          })
        //   console.log(filterItem)
          return filterItem
      }

      onMounted(async()=>{
        //   console.log(newsContent.value)
         let checking = await findContent()
        //  console.log(checking.length)

         if(checking.length === 0){
             window.location.href = '/';
         }
        //   console.log(dataForRender[0].title)
          
        // let titleParams = route.currentRoute.value.params.title
        // console.log(titleParams)
        

        // console.log(this.$route.query.test)
      })
      return{
          newsContent,
          dataForRender,
          recentPost
            
      }
  }
}
</script>

<style lang="scss">
    @import '../Styles/News.scss';
    @import '../Styles/Mobile/News.scss';
</style>